// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1ouUt","header":"Messages_header__1Nr7Z"};